import { render, staticRenderFns } from "./awardsTable.vue?vue&type=template&id=58140ea3"
import script from "./awardsTable.vue?vue&type=script&lang=js"
export * from "./awardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports